<template>
  <v-card flat>
      <v-card-text>
        <v-toolbar flat>
          <v-toolbar-title>
            Users
            <v-chip small>
              {{ users.length||0 }}
            </v-chip>
          </v-toolbar-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-search"
            label="Search"
            single-line
            hide-details
            class="mx-5"
          ></v-text-field>
          <base-admin-dialog 
            title="User"
            v-model="dialog" 
            :save="save"
            :close="close"
            :form-title="formTitle">
            <template #form>
              <v-container grid-list-md  class="pa-1">
                <v-layout wrap>
                  <v-flex xs12 sm3>
                    <v-text-field readonly v-model="editedItem.username" label="Username"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm3>
                    <v-text-field readonly v-model="editedItem.email" label="Email"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm2>
                    <v-text-field readonly v-model="editedItem.emailVerified" label="Verified"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm2>
                    <v-text-field v-model="editedItem.points" label="Points"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm2>
                    <v-checkbox on-icon="check_circle_outline" off-icon="radio_button_unchecked" v-model="editedItem.disable" label="Disable"></v-checkbox>
                  </v-flex>
                  <v-flex xs12 sm2>
                    <v-text-field v-model="editedItem.upgrade" label="Upgrade"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm2>
                    <v-text-field readonly v-model="editedItem.plys" label="Plys"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm2>
                    <v-text-field readonly v-model="editedItem.upvotes" label="Upvotes"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm2>
                    <v-text-field readonly v-model="editedItem.voted" label="Voted"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field readonly v-model="editedItem.lastIp" label="Last IP"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field readonly v-model="editedItem.createdAt" label="Created"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field readonly v-model="editedItem.dtLastSeen.iso" label="Last Seen"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field readonly v-model="editedItem.dtLastLogin.iso" label="Last Login"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </template>
          </base-admin-dialog>
        </v-toolbar>
        <base-admin-table
          dense
          :items-per-page="20"
          :items="users"
          :headers="headers"
          :search="search"
          :loading="loading">
          <template #item="props">
            <tr>
              <td>{{ props.item.objectId }}</td>
              <td>{{ props.item.username }}</td>
              <td>{{ props.item.email }}</td>
              <td>{{ props.item.lastIp }}</td>
              <td>
                <span v-if="props.item.dtLastSeen">
                  {{ props.item.dtLastSeen.iso | asDate }}
                </span>
              </td>
              <td>{{ props.item.createdAt | asDate }}</td>
              <td class="text-no-wrap text-right">
                <v-icon
                  small
                  class="mr-2"
                  @click="editItem(props.item)"
                >
                  edit
                </v-icon>
                <v-icon
                  small
                  @click="deleteItem(props.item)"
                >
                  delete
                </v-icon>
              </td>
            </tr>
          </template>
        </base-admin-table>
      </v-card-text>
  </v-card>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { GET_USERS, UPDATE_USER, SAVE_USER } from '@/store/action-types'
import { SET_USER } from '@/store/mutation-types'
import { BaseAdminDialog, BaseAdminTable } from '@/components/core'
import { copyToClipboard, formatDate } from '@/util/utils'

export default {
  name: 'AdminUsers',
  components: {
    BaseAdminTable,
    BaseAdminDialog
  },
  data() {
    return {
      dialog: false,
      search: '',
      headers: [
        { text: 'ID', align: 'left', sortable: true, value: 'objectId'},
        { text: 'Username', value: 'username'},
        { text: 'Email', value: 'email'},
        { text: 'Last IP', value: 'lastIp'},
        { text: 'Last Seen', value: 'dtLastSeen'},
        { text: 'Created', value: 'createdAt'},
        { text: 'Actions', value: 'name', align: 'right', sortable: false, width: '50 px'}
      ],
      activeIndex: -1,
      defaultItem: {
        username: ''
      },
      editedItem: {
        dtLastSeen: {},
        dtLastLogin: {}
      },
      pagination: {
        rowsPerPage: 10,
        sortBy: 'createdAt',
        descending: true
      }
    }
  },
  created () {
    this.getUsers()
  },
  computed: {
    ...mapState({
      users: state => state.user.all,
      activeUser: state => state.user.user,
      loading: state => state.user.isLoading
    }),
    ...mapGetters([]),
    formTitle () {
      return this.activeIndex === -1 ? 'New User' : 'Edit User'
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    }
  },
  filters: {
      asDate: formatDate
  },
  props: {},
  methods: {
    copyToClipboard,
    getUsers () {
      this.$store.dispatch(GET_USERS)
    },
    editItem(item) {
      this.activeIndex = this.users.indexOf(item)
      this.editedItem = {
        ...this.editedItem,
        ...item
      }
      this.$store.commit(SET_USER, this.editedItem)
      this.dialog = true
    },
    deleteItem (item) {
      const index = this.users.indexOf(item)
      confirm('Are you sure you want to delete this?') && this.users.splice(index, 1)
      //this.$store.dispatch(DELETE_USER, item.objectId)
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.$store.commit(SET_USER, this.defaultItem)
        this.activeIndex = -1
      }, 300)
    },
    save () {
      if (this.activeIndex > -1 && this.activeUser.objectId) {
        // update in db
        this.$store.dispatch(UPDATE_USER, this.activeUser)
      } else {
        // create in db
        this.$store.dispatch(SAVE_USER, this.activeUser)
      }
      // update libraries array
      this.$store.commit(SET_USER, this.activeUser)
      this.close()
    }
  }
}
</script>
